/* import __COLOCATED_TEMPLATE__ from './options.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type HandoffToExternalTicket from 'embercom/models/operator/visual-builder/step/handoff-to-external-ticket';
import { action } from '@ember/object';
interface HandoffData {
  requiresEmailVerification?: boolean;
}

export interface Args {
  step: HandoffToExternalTicket;
  readOnly?: boolean;
}

export default class ExternalTicketHandoffStepComponent extends Component<Args> {
  @service declare intl: IntlService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);

    this.initializeHandoffData();
  }

  private initializeHandoffData() {
    let step = this.args.step as any;

    // Ensure handoffData object exists
    if (!step.handoffData) {
      step.handoffData = {};
    }

    if (step.handoffData.requiresEmailVerification === undefined) {
      step.handoffData.requiresEmailVerification = true;
    }
  }

  private get handoffData(): HandoffData {
    return this.args.step.handoffData;
  }

  @action
  handleEmailVerificationToggle() {
    this.handoffData.requiresEmailVerification = !this.handoffData.requiresEmailVerification;
    this.args.step.handoffData = { ...this.handoffData };
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::ExternalTicketHandoffSteps::Options': typeof ExternalTicketHandoffStepComponent;
  }
}
